import { Typography } from '@mui/material';

import Image from 'src/components/Image';

import {
  Base02TextContainer,
  Button,
  ContentsContainer,
  FlagImageContainer,
  FooterContainer,
  ImageContainer,
  PlayTimeContainer,
  TagBadge,
  TitleContainer,
} from './styled';

import { ReactComponent as NewContentFlagIcon } from 'src/assets/svg/NewContentFlag.svg';
import { ReactComponent as PlayIcon } from 'src/assets/svg/PlayIcon.svg';

type MediaItemProps = {
  title: string;
  tag: string;
  imgURL: string;
  url: string;
  date: string;
  isNew?: boolean;
  playTime?: string;
};

export default function MediaItem({ title, tag, imgURL, url, date, isNew = false, playTime }: MediaItemProps) {
  return (
    <Button onClick={() => window.open(url)}>
      <ImageContainer>
        <Image src={imgURL} />
        {isNew && (
          <FlagImageContainer>
            <NewContentFlagIcon />
          </FlagImageContainer>
        )}
        {playTime && (
          <PlayTimeContainer>
            <PlayIcon />
            <Typography variant="h16">{playTime}</Typography>
          </PlayTimeContainer>
        )}
      </ImageContainer>
      <ContentsContainer>
        <TitleContainer>
          <Typography variant="h6">{title}</Typography>
        </TitleContainer>
        <FooterContainer>
          <TagBadge>
            <Typography variant="h16">{tag}</Typography>
          </TagBadge>
          <Base02TextContainer>
            <Typography variant="h13">{date}</Typography>
          </Base02TextContainer>
        </FooterContainer>
      </ContentsContainer>
    </Button>
  );
}
